import { SimpleGrid } from '@chakra-ui/react';
import useAutoformTableMetadata from './hooks/useAutoformTableMetadata';
import AutoformInputFormikField from './AutoformInputFormikField';
import { parseColumnSettings, parseDateFormat, parseNumberFormat } from './utils/autoformUtils';

const AutoformItemFields = ({ tableId, getInputFormName, mode = 'edit', skipFirstColumn = true }) => {
    const { sortedColumns, selectedItem, dropdownOptions, metadata } = useAutoformTableMetadata(tableId);

    return (
        <SimpleGrid pt={7} pb={5} columns={{ xl: 3 }} spacingX={6} spacingY={4}>
            {sortedColumns
                .filter((_, index) => index !== 0 || !skipFirstColumn)
                .map((column) => {
                    const settings = parseColumnSettings(column.settings);
                    const dateFormat = parseDateFormat(column);
                    const numberFormat = parseNumberFormat(column);
                    return (
                        <AutoformInputFormikField
                            inputName={getInputFormName(tableId, selectedItem, column.name)}
                            key={column.name}
                            inputType={column.inputTypeDescription}
                            inputLabel={column.displayName}
                            placeholder={column.displayName}
                            dataType={column.dataTypeDescription}
                            dropdownOptions={dropdownOptions[column.id]}
                            settings={settings}
                            formats={{
                                dateFormat,
                                numberFormat,
                            }}
                            isDisabled={column.isReadOnly || (!metadata.canUpdate && mode === 'edit')}
                        />
                    );
                })}
        </SimpleGrid>
    );
};

export default AutoformItemFields;
